import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Spinner, Input } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useTranslation } from "react-i18next";
import { getAuthUser } from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchQuestionTypeTableColumnNames, fetchAllQuestionType, createQuestionType, updateQuestionType, 
    deleteQuestionType, activateDeactivateQuestionType, updateUserPreference,    
    fetchTranslation} from "../../../slices/thunks";
import ColumnSelectionModal from "../../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import CommonTable from "../../../Components/Common/Table/CommonTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import AddModal from "../../../Components/Common/Modal/AddModal";
import AddCommonForm2 from "../../../Components/Common/AddCommonForm/AddCommonForm2";
import AddTopicsModalForm from "../../../Components/Common/AddTopicsModalForm/AddTopicsModalForm";
import CommonAddModal from "../../../Components/Common/Modal/CommonAddModal";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";
import AddQuestionTypeForm from "../../../Components/Common/AddQuestionTypeForm/AddQuestionTypeForm";
import usePermissions from "../../../Components/Hooks/usePermissions";


const labels = [
  {
    id: 1,
    labelName: "Name English",
    fieldName: "text-box-translate",
    name: "NameEn",
    value: "NameEn",
    required: true,
    translateTo: "NameAr", 
    errorMessage: "Please Enter Name In English",
  },
  {
    id: 2,
    labelName: "Name Arabic",
    fieldName: "text-box",
    name: "NameAr",
    value: "NameAr",
    required: true,
    errorMessage: "Please Enter Name In Arabic",
  },
  {
    id: 3,
    labelName: "Type Icon",
    fieldName: "file",
    name: "Icon",
    value: "Icon",
    required: true,
  },
]

const actionConfig = {
  edit: {
    icon: "ri-edit-2-line",
    tooltip: "Edit",
  },
  delete: {
    icon: "ri-delete-bin-2-line",
    tooltip: "Delete",
  },
};


function QuestionType () {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const user = getAuthUser();
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [selectedFiles, setselectedFiles] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [lastTranslatedField, setLastTranslatedField] = useState(null);

  const { QuestionType, tableColumnNames, loading, Headerload, module, translationLoading } = useSelector((state) => ({
    QuestionType: state.QuestionType.questionType,
    tableColumnNames: state.QuestionType.tableColumnNames,
    loading: state.QuestionType.loading,
    Headerload: state.QuestionType.Headerload,
    module: state.Module.module,
    translationLoading: state.Module.translationLoading, 
  }));

  // Compute permission
  const permission = (() => {
    return usePermissions(3, 13);
  })();

  const onAddClickHandler = (value) => {
    setShow(true);
    setIsAddOrEdit(value);
    setSelectedRow({});
  };

  const onEditClickHandler = (questionType, value) => {    
    setSelectedRow(questionType);
    setIsAddOrEdit(value);
    setShow(true);
  };
  
  
  const onSubmitHandler = (values, { resetForm, setSubmitting }) => {
    setIsDisabled(true);
     try {
      const finalImageUrl = values.Icon; 

      const imageFieldLabel = labels.find(l => l.name === "Icon" && l.fieldName === "file");
      if (imageFieldLabel?.required && !finalImageUrl) {
          toast.error(t("PleaseUploadTypeIcon") || "Please upload the type icon.");
          setSubmitting(false);
          return;
      }
      
      const questionTypeObj = {
        NameEn: values.NameEn,
        NameAr: values.NameAr,
        Type: 2,
        Icon: finalImageUrl, 
      };

      if (isAddOrEdit === 'isEdit') {
        questionTypeObj.ID = selectedRow.ID;
        dispatch(updateQuestionType(questionTypeObj))
      } else {
        dispatch(createQuestionType(questionTypeObj))
      }
      
      setShow(false); 
      resetForm();    
    } catch (error) {
      console.error("Question Type submission error:", error);
    } finally {
      setIsDisabled(false);
      setSubmitting(false); 
    }
  };

  const handleSave = async () => {
    const preferencesPayload = {
      UserId: user.UserId,
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ColumnId] = selectedColumns.includes(column.ColumnId);
        return acc;
      }, {}),
    };

    setModalOpen(false);
    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await dispatch(fetchQuestionTypeTableColumnNames({ module: "QUESTIONTYPE" }))
      await dispatch(fetchAllQuestionType({ Type: 2 }));


    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

  const confirmDelete = () => {
    dispatch(deleteQuestionType({ Ids: selectedIds, UserId: user.UserId }))
      .then(() => {
        setSelectedIds([]);
      })
      .catch((error) => {
        console.error("Error deleting:", error);
      });
    setDeleteModal(false);
  };

    const onTranslateClickHandler = (targetField, textToTranslate, formikSetFieldValue, sourceFieldName) => {
    if (!textToTranslate || textToTranslate.trim() === "") {
      toast.error(t("EnterTextToTranslate"));
      return;
    }
    setLastTranslatedField(sourceFieldName); 

    dispatch(fetchTranslation({ LangText: textToTranslate }))
      .unwrap() 
      .then(translatedText => {
        formikSetFieldValue(targetField, translatedText);
      })
      .catch(error => {
        console.error("Translation error:", error);
        toast.error(t("TranslationFailed"));
      })
      .finally(() => {
        setLastTranslatedField(null); 
      });
  };

  const onActiveOrDeactiveChange = (questionType, e) => {
    dispatch(activateDeactivateQuestionType({ ID: questionType.ID, IsActive: questionType.IsActive, UserId: user.UserId }));
  };

  useEffect(() => {
    dispatch(fetchQuestionTypeTableColumnNames({ module: "QUESTIONTYPE" }))
    dispatch(fetchAllQuestionType({ Type: 2 }));

  }, [dispatch]);

  // Effect to clear form data when modal is closed
  useEffect(() => {
    if (!show) {
      setSelectedRow({}); 
      setselectedFiles([]); 
    }
  }, [show]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t('Question Type')} />
          </Col>
        </Row>
        <div className="table-responsive">
          <Card>
            <CardHeader>
               <Row className="g-4 ">
                  <Col className="col-sm-auto">
                    <div>
                      <Button
                        className="btn btn-soft-danger ms-2 me-2"
                        onClick={() => setDeleteModal(true)}
                        disabled={selectedIds.length === 0}
                      >
                        <i className="ri-delete-bin-2-line"></i>
                      </Button>
                      {permission.CanAdd && (
                        <Button
                          color="secondary"
                          className="add-btn me-1"
                          onClick={() => onAddClickHandler("isAdd")}
                          id="create-btn"
                        >
                          <i className="ri-add-line align-bottom me-1 ms-1"></i>
                          {t("AddNew")}
                        </Button>
                      )}
                    </div>
                  </Col>
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <Button
                        className="btn btn-soft"
                        onClick={() => setModalOpen(true)}
                      >
                        <i className="ri-filter-3-line"></i>
                      </Button>
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
                </Row> 
            </CardHeader>

            <CardBody>
              <div className="listjs-table" id="customerList">
                {loading || Headerload ? (
                  <div className="d-flex justify-content-center align-items-center">
                  <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                    Loading...
                  </Spinner>
                  </div>
                ) : (
                  <div className="listjs-table" id="customerList">
                    {/* <CommonTable
                      data={QuestionType}
                      tableColumnNames={tableColumnNames}
                      searchTerm={searchTerm}
                      onEditClickHandler={onEditClickHandler}
                      onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                      setDeleteModal={setDeleteModal}
                      setSelectedIds={setSelectedIds}
                      hasAction={true}
                      permission={permission}
                    /> */}
                     <CommonDataTable
                        data={QuestionType || []}
                        tableColumnNames={tableColumnNames || []}
                        searchTerm={searchTerm}
                        onEditClickHandler={onEditClickHandler}
                        onActiveOrDeactiveChange={onActiveOrDeactiveChange}
                        setDeleteModal={setDeleteModal}
                        setSelectedIds={setSelectedIds}
                        actionConfig={actionConfig}
                        permission={permission}
                      />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>

      {/* Modal  */}
      <CommonAddModal
            show={show}
            setShow={setShow}
            onSubmitHandler={onSubmitHandler}
            labels={labels}
            isAddOrEdit={isAddOrEdit}
            selectedItemData={selectedRow} 
            FormBody={AddQuestionTypeForm}
            FormBodyProps={{ 
              onTranslateClickHandler, 
              translationLoading,
              lastTranslatedField,
              setParentSubmitDisabled: setIsDisabled, 
            }}
            title={isAddOrEdit === "isAdd" ? t("Add New Question Type") : t("Edit Question Type")}
            size="lg" 
            isDisabled={isDisabled} 
      />

      {/* ColumnSelectionModal */}
      <ColumnSelectionModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        columns={tableColumnNames}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleSave={handleSave}
      />

      {/* Delete modal  */}
      <DeleteModal
        showDelete={deleteModal}
        setShowDelete={setDeleteModal}
        onDeleteClick={confirmDelete}
        setSelectedIds={setSelectedIds}
        description={`Are you sure you want to delete this record?`}
      />
    </div>
  );
}

export default QuestionType;